import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {signup} from '../../services/auth-service';
import MinimalLayout from "../../layouts/minimal";
import {ErrorMessage, Field, Form, Formik} from "formik";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {loginRequestSchema, signupRequestSchema} from "../../utils/schemas";
import {useGlobalNotificationMessage} from "../../context/message";
import {AppRoutes, Links} from "../../utils/constants";
import FormGroup from "../../components/form-group";

export default function Signup () {
  const [submitted, setSubmitted] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    signup(values).then((responseData) => {
      setSubmitted(true);
    }).catch(error => {
      if( error.response.status===409 ){
        HelperService.handleApiErrors(error, addErrorMessage, "User already registered, please sign in instead.");
        return;
      }
      HelperService.handleApiErrors(error, addErrorMessage, "Registration failed. Please verify information, you entered and try again.");
      HelperService.handleFormErrors(error, setErrors);
    }).finally(()=>{setSubmitting(false);});
  };

  return (
      <>
        <Section animation={HelperService.getRandomAnimation()} className="bg-image">

          <div className="container">
            <div className="row justify-content-center align-items-center h100 py-5">
              <div className="col-xxl-8 col-lg-8">

                <div className="text-center pb-5">
                  <Link to={AppRoutes.landing.path}>
                    <span><img src="/assets/images/logo.svg" alt="" height="120"/></span>
                  </Link>
                </div>

                <div className="card">

                  {submitted && <div className="card-body p-4">
                    <div className={"my-2 p-2 text-center"}>
                      <span className="mdi mdi-check-circle-outline mb-2 text-success"
                            style={{'fontSize': '50px'}}></span><br/>
                      <h4>Registration successful</h4>
                      <p className="px-5">We have sent you email to confirm your email address. Please follow the instructions in your email to confirm it and then <Link to={AppRoutes.login.path} className={"link-dark w-100"}>log in</Link> to start using the app.</p>
                    </div>
                  </div>}

                  {!submitted && <div className="card-body p-4">
                    <div className="text-center w-75 m-auto">
                      <h4 className="text-dark-50 text-center pb-0 fw-bold">Create account</h4>
                      <p className="text-muted mb-4">Create your Sweat Now account using email</p>
                    </div>
                    <Formik
                        initialValues={signupRequestSchema.cast()}
                        validationSchema={signupRequestSchema}
                        onSubmit={handleSubmit}
                    >
                      {({isSubmitting, errors, touched}) => (
                          <Form className="row">
                            <div className="mb-3 col-md-6">
                              <label htmlFor="name" className="form-label">Name</label>
                              <Field required
                                     name="name"
                                     placeholder="First name"
                                     className={`form-control ${errors.name && touched.name ? "is-invalid" : ""}`}/>
                              <ErrorMessage name="name" component="div" className="invalid-feedback"/>
                            </div>
                            <div className="mb-3 col-md-6">
                              <label htmlFor="surname" className="form-label">Surname</label>
                              <Field required
                                     name="surname"
                                     placeholder="Surname name"
                                     className={`form-control ${errors.surname && touched.surname ? "is-invalid" : ""}`}/>
                              <ErrorMessage name="surname" component="div" className="invalid-feedback"/>
                            </div>
                            <div className="mb-3 col-md-6">
                              <label htmlFor="email" className="form-label">Email</label>
                              <Field required
                                     name="email"
                                     type="email"
                                     placeholder="example@sweatnow.com"
                                     className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`}/>
                              <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                            </div>
                            <div className="mb-3 col-md-6">
                              <label htmlFor="mobile" className="form-label">Mobile</label>
                              <Field name="mobile"
                                     placeholder="Number with area code"
                                     className={`form-control ${errors.mobile && touched.mobile ? "is-invalid" : ""}`}/>
                              <ErrorMessage name="mobile" component="div" className="invalid-feedback"/>
                            </div>
                            <FormGroup
                                name="password"
                                type="password"
                                autoComplete="new-password"
                                placeholder="****"
                                label="Password"
                                className="mb-3 col-md-6"
                                touched={touched} errors={errors}
                                schema={signupRequestSchema}
                            />
                            <FormGroup
                                name="password_confirmation"
                                type="password"
                                autoComplete="new-password"
                                placeholder="****"
                                label="Confirm password"
                                className="mb-3 col-md-6"
                                touched={touched} errors={errors}
                                schema={signupRequestSchema}
                            />
                            <div className={"text-center mt-2"}>
                              <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>Confirm
                              </button>
                            </div>
                          </Form>
                      )}
                    </Formik>
                    <hr className={"mt-5 d-block"}/>
                    <p className="text-center">
                      <Link to={AppRoutes.login.path} className={"link-dark w-100"}>Back to login methods</Link>
                    </p>
                  </div>}
                </div>
                <div className="text-center mt-3 fs-7 text-muted">By login up, signing up you agree to SweatNow's <a
                    href={Links.terms} target="terms">Terms of Use</a></div>

              </div>
            </div>
          </div>

        </Section>
      </>
  );
}


Signup.getLayout = function getLayout(page) {
  return (
      <MinimalLayout>
      {page}
      </MinimalLayout>
  )
}
